

export const WarrantyPage = () => {
    return (
        <div className="">
            WarrantyPage
        </div>
    )
}

export default WarrantyPage